import React from 'react';
import { Row, Col, Skeleton } from 'antd';

import {
  returnCorStatusSolicitacaoText,
  returnCorStatusSolicitacaoOpacity,
} from '../../utils';

import * as S from '../styles';

export function CabecalhoModal({ data, loading }) {
  return (
    <Row style={{ paddingBottom: '18px' }}>
      {loading && (
        <>
          <Col span={4}>
            <Skeleton
              active
              size="small"
              loading={loading}
              paragraph={{ rows: 0 }}
            />
          </Col>
          <Col span={4}>
            {' '}
            <Skeleton
              active
              size="small"
              loading={loading}
              paragraph={{ rows: 0 }}
            />
          </Col>
          <Col span={4}>
            {' '}
            <Skeleton
              active
              size="small"
              loading={loading}
              paragraph={{ rows: 0 }}
            />
          </Col>
          <Col span={4}>
            {' '}
            <Skeleton
              active
              size="small"
              loading={loading}
              paragraph={{ rows: 0 }}
            />
          </Col>
        </>
      )}
      {!loading && (
        <Row gutter={40}>
          <Col>
            <S.ModalTitlesolicitacao>
{`Solicitação: ${data?.idIntegracao ||
              '-'}`}
            </S.ModalTitlesolicitacao>
          </Col>
          <Col>
            <S.ModalTitlesolicitacao
              color="#828282"
              weight="400"
              size="14px"
            >
{'Matriz: '}
            </S.ModalTitlesolicitacao>
            <S.ModalTitlesolicitacao weight="400" size="14px">
              {data?.matrizNome || '-'}
            </S.ModalTitlesolicitacao>
          </Col>
          <Col
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <S.ModalTitlesolicitacao
              color="#828282"
              weight="400"
              size="14px"
            >
{'Status: '}
            </S.ModalTitlesolicitacao>
            {data?.descricaoStatus && (
              <>
                <S.StatusIcon
                  color={returnCorStatusSolicitacaoOpacity(
                    data?.descricaoStatus
                  )}
                >
                  <S.BadgeStatus
                    color={returnCorStatusSolicitacaoText(
                      data?.descricaoStatus
                    )}
                  />
                </S.StatusIcon>
                <S.ModalTitlesolicitacao weight="400" size="14px">
                  {data?.descricaoStatus || '-'}
                </S.ModalTitlesolicitacao>
              </>
            )}
          </Col>
          <Col>
            <S.ModalTitlesolicitacao
              color="#828282"
              weight="400"
              size="14px"
            >
{'Usuário: '}
            </S.ModalTitlesolicitacao>
            <S.ModalTitlesolicitacao weight="400" size="14px">
              {data?.nome || '-'}
            </S.ModalTitlesolicitacao>
          </Col>
        </Row>
      )}
    </Row>
  );
}
